// extracted by mini-css-extract-plugin
export var chevron = "_1j-d";
export var disabled = "_1j-b";
export var error = "_1j-c";
export var hideBorder = "_1j-1";
export var icon = "_1j-e";
export var input = "_1j-0";
export var large = "_1j-f";
export var open = "_1j-9";
export var placeholder = "_1j-a";
export var regular = "_1j-5";
export var singleRowInput = "_1j-2";
export var singleSelectInput = "_1j-3 _1j-0";
export var small = "_1j-4";
export var spinnerContainer = "_1j-i";
export var tag = "_1j-7";
export var tagsContainer = "_1j-8";
export var tagsInput = "_1j-6 _1j-0";
export var xSmall = "_1j-g";
export var xxSmall = "_1j-h";